  (function(){

        var myObj = {
            resolver:null
        };

        myObj.checker = function(){
            if(typeof window.jQuery=="undefined"){
                window.requestAnimationFrame(this.checker);
            }else{
                this.resolver("ready");
            }
        }

        myObj.resolveAfterLoad = function() {
            return new Promise(resolve => {
                this.resolver = resolve;
                window.requestAnimationFrame(this.checker);
            });
        }

        myObj.scrollPage = function(e){
            e.preventDefault;


            var $scrollTarget = $($(e.currentTarget).attr("href"));
            //check if target ID exists on DOM
            if($scrollTarget.length>0){
                var headerHeight =  $("header").length>0?$("header").outerHeight():0;
                //subtrack header height from scoll offset
                var scrollerAmt = $scrollTarget.offset().top - headerHeight;
                $("html, body").animate({
                    scrollTop: scrollerAmt
                }, 500);
            }
        }

        myObj.init = function(){
            $("[data-hash-scroller]").each(function(){
                $(this).click(myObj.scrollPage);
            });
        }

        async function initCheck() {
            const result = await myObj.resolveAfterLoad();
            if(result=="ready"){
                myObj.init();
            }
        }

        myObj.checker = myObj.checker.bind(myObj);
        myObj.init =  myObj.init.bind(myObj);
        myObj.resolveAfterLoad = myObj.resolveAfterLoad.bind(myObj);
        
        initCheck();

    })();